<template>
  <fn-form
    hide-errors
    @submit="onSubmit"
  >
    <fn-loading-overlay v-if="loading" />

    <div class="welcome-back">
      <div class="welcome-back-text">
        <fn-headline
          type="h2"
          size="h4"
          color="black"
        >
          {{ $t('friendsLight.login.headline') }}
        </fn-headline>
      </div>
    </div>

    <fn-form-group class="consents">
      <fn-form-section>
        <fn-form-field-checkbox
          v-if="!hasFriendsBenefit"
          id="fld-friends-doi"
          :value="forms.friends.registration.consent"
          name="friendsTos"
          type="checkbox"
          rules="required"
        >
          <template #afterLabel>
            <i18n-t
              keypath="forms.friends.registration.consent"
              tag="p"
              class="checkbox-label-after--privacynotice"
            >
              <template #terms>
                <fn-link
                  inline
                  target="_blank"
                  :to="$t('forms.friends.registration.tosUrl')"
                >
                  {{ $t('forms.friends.registration.terms') }}
                </fn-link>
              </template>
            </i18n-t>
          </template>
        </fn-form-field-checkbox>
      </fn-form-section>

      <fn-form-section>
        <fn-form-field-checkbox
          v-if="showNewsletterCheckbox"
          id="fld-newsletter-doi"
          :value="forms.newsletter.privacyNotice.consent"
          name="newsletterConsent"
          type="checkbox"
        >
          <template #afterLabel>
            <i18n-t
              keypath="forms.newsletter.privacyNotice.text"
              tag="p"
              class="checkbox-label-after--privacynotice"
            >
              <template #privacyNotice>
                <fn-link
                  inline
                  target="_blank"
                  :to="$t('forms.newsletter.privacyNotice.privacyUrl')"
                >
                  {{ $t('forms.newsletter.privacyNotice.privacyNotice') }}
                </fn-link>
              </template>
            </i18n-t>
          </template>
        </fn-form-field-checkbox>
      </fn-form-section>
    </fn-form-group>

    <fn-form-group v-if="!buttonDisabled">
      <fn-form-section>
        <fn-button
          id="fld-userData-submit"
          secondary
          submit
          full-width
        >
          {{ $t('friendsLight.login.buttonQrCode') }}
        </fn-button>
      </fn-form-section>
    </fn-form-group>

    <client-only>
      <fn-form-group v-if="showNewsletterRecaptcha">
        <fn-form-section>
          <fn-recaptcha
            ref="newsletterRecaptcha"
            @verify="onRecaptchaVerify"
          />
        </fn-form-section>
      </fn-form-group>
    </client-only>
  </fn-form>
</template>

<script>
import { actions } from '@/utils/recaptcha';
import Newsletter from '@/mixins/Newsletter';

export default defineComponent({
  mixins: [Newsletter],
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
    buttonDisabled: {
      type: Boolean,
    },
    requiredNotice: {
      type: Boolean,
    },
    legalHidden: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    fullWidthInputs: {
      type: Boolean,
    },
    friendsLight: {
      type: Boolean,
    },
  },
  emits: ['submit'],
  data: () => ({
    fields: {
      newsletterRecaptchaResponse: null,
    },
    forms: {
      friends: {
        registration: {
          consent: false,
        },
      },
      newsletter: {
        privacyNotice: {
          consent: false,
        },
      },
    },
  }),
  computed: {
    ...mapState(useMainStore, {
      newsletterRecaptchaEnabled: 'getNewsletterRecaptchaEnabled',
    }),
    ...mapState(useUserStore, {
      termsOfServiceAccepted: 'termsOfServiceAccepted',
      friendsLightQrCode: 'getFriendsLightQrCode',
      hasFriendsBenefit: 'getHasFriendsBenefit',
    }),
  },
  methods: {
    async onSubmit(values) {
      if (this.showNewsletterRecaptcha) {
        await this.$refs.newsletterRecaptcha.execute(actions.newsletter);
      }

      if (!this.hasFriendsBenefit && values.newsletterConsent) {
        this.fields.friendsTos = true;
      }

      if (values.newsletterConsent) {
        this.fields.newsletterConsent = true;
      }

      this.$emit('submit', this.fields);
    },
    onRecaptchaVerify(recaptchaFields = {}) {
      this.fields.newsletterRecaptchaResponse = recaptchaFields.recaptchaResponse;
    },
  },
});
</script>

<style lang="scss" scoped>
.welcome-back {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: $pad;
  background-color: palette(grey, lighter);
  border-radius: map-get($border-radiuses, 'xl');

  .welcome-back-text {
    :deep(.heading) {
      margin-bottom: 0;
    }
  }
}

.consents {
  margin: 1.5 * $pad 0;

  :deep(.checkbox) {
    .checkbox-label-after {
      margin-left: 0;
    }

    .checkbox-label-after--privacynotice {
      display: inline;
    }
  }
}

.form-required-notice {
  margin-bottom: math.div($space, 4);
  margin-right: $pad * 2;
}
</style>
